<template>
  <div class="order">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="待发货" name="1">
                <div class="search">
                    <el-input v-model="orderid" placeholder="订货单ID"></el-input>
                    <el-input v-model="ordernum" placeholder="订货单名称"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="listbtn">
                    <el-button  v-preventReClick type="primary" icon="el-icon-plus" @click="add()">新增订货单</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="id"
                            label="订货单ID"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="orderName"
                            label="订货单名称"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            prop="state"
                            width="150"
                            label="状态">
                            <template slot-scope="scope">
                                {{scope.row.state == 1?'待发货': scope.row.state == 2?'待收货':'已收货'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="sum"
                            width="150"
                            label="订货数量">
                        </el-table-column>
                        <!-- <el-table-column
                            prop="deviceList"
                            width="150"
                            label="订货明细">
                            <template slot-scope="scope">
                                {{scope.row.deviceList.map(item=>{
                                    return item.deviceName+':'+item.number+'个'
                                }).toString()}}
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            width="150"
                            prop="trackingNumber"
                            label="物流单号">
                        </el-table-column>
                        <el-table-column
                            prop="consignee"
                            label="收货人">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            label="联系方式">
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="创建日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row.id)">查看</el-link>
                                <el-link :underline="false" @click="deletes(scope.row)" style="color:#F56C6C">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="待收货" name="2">
                <div class="search">
                    <el-input v-model="orderid" placeholder="订货单ID"></el-input>
                    <el-input v-model="ordernum" placeholder="订货单名称"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="listbtn">
                    <el-button  v-preventReClick type="primary" icon="el-icon-plus" @click="add()">新增订货单</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData1"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="id"
                            label="订货单ID"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="orderName"
                            label="订货单名称"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            prop="state"
                            width="150"
                            label="状态">
                            <template slot-scope="scope">
                                {{scope.row.state == 1?'待发货': scope.row.state == 2?'待收货':'已收货'}}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            prop="deviceList"
                            width="150"
                            label="订货明细">
                            <template slot-scope="scope">
                                {{scope.row.deviceList.map(item=>{
                                    return item.deviceName+':'+item.number+'个'
                                }).toString()}}
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            prop="sum"
                            width="150"
                            label="订货数量">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="trackingNumber"
                            label="物流单号">
                        </el-table-column>
                        <el-table-column
                            prop="consignee"
                            label="收货人">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            label="联系方式">
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="创建日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="sure(scope.row.id)">确认收货</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="已收货" name="3">
                <div class="search">
                    <el-input v-model="orderid" placeholder="订货单ID"></el-input>
                    <el-input v-model="ordernum" placeholder="订货单名称"></el-input>
                    <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
                </div>
                <div class="listbtn">
                    <el-button  v-preventReClick type="primary" icon="el-icon-plus" @click="add()">新增订货单</el-button>
                </div>
                <div class="tablelist">
                    <el-table
                        :data="tableData2"
                        :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                        style="width: 100%">
                        <el-table-column
                            prop="id"
                            label="订货单ID"
                            width="120">
                        </el-table-column>
                        <el-table-column
                            prop="orderName"
                            label="订货单名称"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            prop="state"
                            width="150"
                            label="状态">
                            <template slot-scope="scope">
                                {{scope.row.state == 1?'待发货': scope.row.state == 2?'待收货':'已收货'}}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            prop="deviceList"
                            width="150"
                            label="订货明细">
                            <template slot-scope="scope">
                                {{scope.row.deviceList.map(item=>{
                                    return item.deviceName+':'+item.number+'个'
                                }).toString()}}
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            prop="sum"
                            width="150"
                            label="订货数量">
                        </el-table-column>
                        <el-table-column
                            width="150"
                            prop="trackingNumber"
                            label="物流单号">
                        </el-table-column>
                        <el-table-column
                            prop="consignee"
                            label="收货人">
                        </el-table-column>
                        <el-table-column
                            prop="phone"
                            label="联系方式">
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="创建日期">
                        </el-table-column>
                        <el-table-column
                            prop=""
                            label="操作">
                            <template slot-scope="scope">
                                <el-link :underline="false" @click="look(scope.row.id)">查看</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <div class="page">
                    <el-pagination
                        :background="true"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
            </div>
      </el-tabs>
      <!-- 新增订货单 -->
      <el-dialog
        title="新增"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="40%"
        >
         <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
                        <el-form-item label="订货单名称" >
                            <el-input v-model="ruleForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="收货人" prop="person">
                            <el-input v-model="ruleForm.person"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="ruleForm.phone" maxlength="11"></el-input>
                        </el-form-item>
                        <el-form-item label="添加设备" prop="value">
                            <el-checkbox-group v-model="checkList" @change="selectcheck">
                                <el-checkbox v-for="(item,index) in states" :key="index" :label="item.deviceName" @change="selectcheck1(item)" @click="selectcheck2"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="所需设备" prop="need">
                          <div class="ordernote">
                            <el-table
                                :data="tableDataorder"
                                :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
                                style="width: 100%">
                                <el-table-column
                                    prop="id"
                                    label="设备ID"
                                    width="120px"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="deviceName"
                                    label="设备名称"
                                    width="150px"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="number"
                                    width="120px"
                                    label="数量">
                                    <template slot-scope="scope">
                                                <el-input v-model="scope.row.number" @blur="inputnum"></el-input>
                                                <!-- <el-form :model="ruleForms" :rules="rules1" ref="ruleForms" label-width="0" class="demo-ruleForm">
                                                    <el-form-item label="" prop="number">
                                                        <el-input v-model="scope.row.number"></el-input>
                                                    </el-form-item>
                                                </el-form> -->
                                    </template>
                                    
                                </el-table-column>
                                <el-table-column
                                    prop="数量"
                                    label="操作">
                                    <template slot-scope="scope">
                                        <el-link :underline="false" @click="remove(scope.row)">移除</el-link>
                                    </template> 
                                </el-table-column>
                            </el-table>
                          </div>
                        </el-form-item>
         </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisible = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="submit()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script> 
import {selectAllOrder,ordersearch,list,deleteOrder,addOrder,selectPhoneAndName} from '../axios/api'
export default {
    data(){
        // var validatornum = (value,rule,callback) =>{
        //     console.log(value,rule,callback,this.tableDataorder)
        //      this.tableDataorder.forEach( item=>{
        //             if(item.number == ''){
        //                 this.$message.error('请填写所需设备数量')
        //                 return
        //             }else if(!Number(item.number)){
        //                 this.$message.error('请填写正确的设备数量')
        //                  return
                       
        //             }else if(item.number < 1){
        //                 this.$message.error('设备数量最小为1')
        //                 return
        //             }
        //         })
                
        // }
        // var validatorphone = (value,rule,callback) =>{
        //     console.log(value,rule,callback)
        //     if(value == ''){
        //          return callback(new Error('请输入手机号'));
        //     }else if(!(/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/).test(value)){
        //         return callback('手机号格式不正确')
        //     }else{
        //         callback()
        //     }
        // }
        return{
            activeName: '1',
            orderid:'',
            ordernum:'',
            tableData:[],
            tableData1:[],
            tableData2:[],
            total:0,
            page:1,
            dialogVisible: false,
            currentPage4:1,
            ruleForm:{
                name:'',
                person:'',
                phone:'',
                value: [],
            },
            rules:{
                person:[
                    {required:true,message:'请输入收货人',trigger:'blur'}
                ],
                phone:[
                    {required:true,message:'请输入手机号',trigger:'blur',}
                ]
            },
            options: [],
            list: [],
            loading: false,
            states: ['鲁诺路程','鲁诺忆成','黑马'],
            tableDataorder:[],
            tabid:1,
            ruleForms:{
                number:''
            },
            rules1:{
                // validator:validatornum,
                number:[{required: true, trigger: 'blur' }]
            },
            getstates:0,
            checkList: [],
            devicevalue:{},
            consignee:'',
            phones:''

        }
    },
    created(){
        this.getdata()
        this.getdevice()
    },
    methods:{
        handleClick(tab, event) {
            console.log(tab, event);
            this.orderid = ''
            this.ordernum='',
            this.tabid = tab.name
            this.getdata()
        },
        async getdevice(){
            var {data:dt} = await list({})
            console.log(dt)
            if(dt.code == 200){
                this.states = dt.data.data
            }
            // console.log(this.list)
            //  this.list = this.states.map(item => {
            //     return { value: `${item.deviceName}`, label: `${item.deviceName}`,id:`${item.id}` };
            // });
        },
       async add(){
            var {data:dt} = await selectPhoneAndName({
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.ruleForm.person = dt.data.pn.consignee?dt.data.pn.consignee:''
               this.ruleForm.phone = dt.data.pn.phone?dt.data.pn.phone:''
            }
            this.ruleForm.name = ''
            // this.ruleForm.person =  this.consignee?this.consignee:''
            // this.ruleForm.phone = this.phones?this.phones:''
            this.ruleForm.value = ''
            this.tableDataorder = []
            this.checkList = []
            this.dialogVisible = true
        },
        look(id){
            this.$router.push({
                name:'订货单详情',
                params:{
                    id:id
                }
            })
        },
          submit(){ 
              this.$refs.ruleForm.validate(async(valid) => {
                    if (valid) {
                        if(this.tableDataorder.length == 0){
                        this.$message.error('请添加所需设备')
                        return
                    }else{
                        console.log(this.tableDataorder)
                        let arr = this.tableDataorder.map( item=>{
                            return item.number
                        })
                        for(var i=0;i<arr.length;i++){
                            console.log(arr[i])
                            if(arr[i] == ''){
                                this.$message.error('请填写所需设备数量')
                                return 
                            }else if(!Number(arr[i])){
                                this.$message.error('请填写正确的设备数量')
                                return 
                            
                            }else if(arr[i] < 1){
                                this.$message.error('设备数量最小为1')
                                return 
                            }
                        }
                            var {data:dt} = await addOrder({
                                shopAdminId:window.localStorage.getItem('shopId'),
                                orderName:this.ruleForm.name,
                                consignee:this.ruleForm.person,
                                phone:this.ruleForm.phone,
                                deviceList:this.tableDataorder
                            })
                            console.log(dt)  
                            if(dt.code == 200){
                                this.$message.success(dt.message)
                                this.dialogVisible = false
                                this.getdata()
                            }
                        
            }
                    }
              })
   
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.getstates == 0){
                this.getdata()
            }else{
                this.search1()
            }
        },
        deletes(row){
            console.log(row)
            this.$confirm('删除后数据不可恢复，确认删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await deleteOrder({
                        shopAdminId:window.localStorage.getItem('shopId'),
                        orderId:row.id
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message.success(dt.message)
                        this.getdata()
                    }
                })
        },
        sure(id){
            this.$router.push({name:'订货单详情',params:{flag:1,id:id}})
        },
        inputnum(e){
            console.log(e.target.value)
        },
        remove(row){
            console.log(row,this.tableDataorder)
             for(var i=0;i<this.tableDataorder.length;i++){
                if(this.tableDataorder[i].id == row.id){
                    this.tableDataorder.splice(i,1)
                    this.$message.success('移除成功')
                }
            }
            this.checkList = this.tableDataorder.map(item=>{
                return item.deviceName
            })
        },
        async getdata(){
            this.getstates = 0
            var {data:dt} = await selectAllOrder({
                current:this.page,
                limit:10,
                state:this.tabid,
                shopAdminId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                if(this.tabid == 1){
                    this.tableData = dt.data.records
                    this.total = dt.data.total
                }else if(this.tabid == 2){
                    this.tableData1 = dt.data.records
                    this.total = dt.data.total
                }else if(this.tabid == 3){
                    this.tableData2 = dt.data.records
                    this.total = dt.data.total
                }
            }
        },
        async search(){
            this.getstates = 1
            var {data:dt} = await ordersearch({
                current:1,
                limit:10,
                shopAdminId:window.localStorage.getItem('shopId'),
                state:this.tabid,
                id :this.orderid,
                orderName:this.ordernum
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                if(this.tabid == 1){
                    this.tableData = dt.data.records
                    this.total = dt.data.total
                }else if(this.tabid == 2){
                    this.tableData1 = dt.data.records
                    this.total = dt.data.total
                }else if(this.tabid == 3){
                    this.tableData2 = dt.data.records
                    this.total = dt.data.total
                }
            }
        },
        async search1(){
            this.getstates = 1
            var {data:dt} = await ordersearch({
                current:this.page,
                limit:10,
                shopAdminId:window.localStorage.getItem('shopId'),
                state:this.tabid,
                id :this.orderid,
                orderName:this.ordernum
            })
            console.log(dt)
            if(dt.code == 200){
                if(this.tabid == 1){
                    this.tableData = dt.data.records
                    this.total = dt.data.total
                }else if(this.tabid == 2){
                    this.tableData1 = dt.data.records
                    this.total = dt.data.total
                }else if(this.tabid == 3){
                    this.tableData2 = dt.data.records
                    this.total = dt.data.total
                }
            }
        },
        selectcheck(value){
            console.log(value,value.length)
                if(value.indexOf(this.devicevalue.deviceName) == -1){
                    //  -1就是不存在与数组中
                    console.log(this.tableDataorder)
                    for(var i=0;i<this.tableDataorder.length;i++){
                        if(this.tableDataorder[i].id == this.devicevalue.id){
                            this.tableDataorder.splice(i,1)
                            this.$message.success('移除成功')
                        }
                    }
                }else{
                    value.forEach(item=>{
                        console.log(item == this.devicevalue.deviceName)
                        if(item == this.devicevalue.deviceName){
                            var obj = {
                                id :this.devicevalue.id,
                                deviceName:item,
                                number:'' 
                            }
                            this.tableDataorder.push(obj)
                        }
                    })
                }
        },
        selectcheck1(value){
            console.log(value)
            this.devicevalue = value
        },
        selectcheck2(value){
            console.log(value)
        },
    }
}

</script>
<style lang="less" scoped>
.order{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link .el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
    .ordernote{
        /deep/.el-table td div{
            height: 65px!important;
            line-height: 65px;
        }
        /deep/.el-form-item__error{
            margin-top: -43px;
        }
        /deep/.el-table .cell{
            line-height: 65px;  
        }
        /deep/.el-input__inner{
            height: 34px;
            line-height: 34px;
            position: relative;
            z-index: 999999;
        }
        /deep/.el-table td, .el-table th{
            padding: 6px 0;
        }
    }
}
</style>
<style>
.el-link.el-link--default{
     color: #409eff;
    margin-right: 12px;
}
</style>




























